import { render, staticRenderFns } from "./LibraryMenu.vue?vue&type=template&id=f04de112&scoped=true&"
import script from "./LibraryMenu.vue?vue&type=script&lang=js&"
export * from "./LibraryMenu.vue?vue&type=script&lang=js&"
import style0 from "./LibraryMenu.vue?vue&type=style&index=0&id=f04de112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04de112",
  null
  
)

export default component.exports